import React2, { createContext, useMemo, useContext } from 'react';

// src/features/featureDefaults.ts
var FEATURE_DEFAULTS = {
  calls: true,
  videophone: true,
  openDoor: true,
  camera: true,
  contacts: true,
  photos: true,
  voicemail: true,
  callHistory: true,
  games: true,
  agenda: true,
  weather: true,
  news: true,
  info: true,
  // Always-on / non-toggleable.
  emergency: true
};

// src/features/mergeFeatureFlags.ts
function mergeFeatureFlags(codeDefaults, buildingOverrides) {
  const merged = { ...codeDefaults, ...buildingOverrides ?? {} };
  merged.emergency = true;
  return merged;
}
var FeaturesContext = createContext(null);
function FeatureProvider({
  features,
  children
}) {
  const value = useMemo(() => {
    const isEnabled = (feature) => {
      if (feature === "emergency") return true;
      return features[feature] === true;
    };
    return { features, isEnabled };
  }, [features]);
  return React2.createElement(FeaturesContext.Provider, { value }, children);
}
function useFeatures() {
  const ctx = useContext(FeaturesContext);
  if (!ctx) {
    throw new Error("useFeatures must be used within a <FeatureProvider>");
  }
  return ctx;
}
function FeatureGate({
  feature,
  children,
  fallback = null
}) {
  const { isEnabled } = useFeatures();
  if (!isEnabled(feature)) {
    return fallback ?? null;
  }
  return React2.createElement(React2.Fragment, null, children);
}

// src/types/features.ts
var TOGGLEABLE_FEATURES = [
  "calls",
  "videophone",
  "openDoor",
  "camera",
  "contacts",
  "photos",
  "voicemail",
  "callHistory",
  "games",
  "agenda",
  "weather",
  "news",
  "info"
];

export { FEATURE_DEFAULTS, FeatureGate, FeatureProvider, TOGGLEABLE_FEATURES, mergeFeatureFlags, useFeatures };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map